import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StravaSectionsElementComponent } from '../stravaSectionsElement/stravaSectionsElement.component';
import { NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StravaSection } from '@kinomap-dev/ng-ui-lib/lib/models/strava-section.model';

@Component({
  selector: 'watch-Strava-sections-modal',
  templateUrl: './watchStravaSectionsModal.component.html',
  styleUrls: ['./watchStravaSectionsModal.component.scss'],
  standalone: true,
  imports: [TranslateModule, NgFor, StravaSectionsElementComponent, NgIf],
})
export class WatchStravaSectionsModalComponent implements OnInit {
  xSmallScreen: boolean;
  subscriptions: Subscription[] = [];
  @Input() sectionsStrava!: StravaSection[];

  constructor(private responsive: BreakpointObserver) {}

  ngOnInit(): void {
    this.subscriptions = [
      ...this.subscriptions,
      this.responsive.observe(Breakpoints.XSmall).subscribe((result) => {
        this.xSmallScreen = result.matches ? true : false;
      }),
    ];
  }
}
